export default __webpack_public_path__ + "static/media/22.b88a0045.jpg";